import {RequestStatus} from "interfaces";

type Status = "initial" | "success" | "error";

export const setRequestStatus = (
  status: Status,
  initial: RequestStatus = {
    isLoading: true,
    success: false,
    error: false,
  }
): RequestStatus => {
  let API_STATUS = {} as RequestStatus;

  switch (status) {
    case "error":
      API_STATUS["error"] = true;
      API_STATUS["success"] = false;
      API_STATUS["isLoading"] = false;
      break;
    case "success":
      API_STATUS["error"] = false;
      API_STATUS["success"] = true;
      API_STATUS["isLoading"] = false;
      break;
    default:
      API_STATUS["error"] = initial["error"];
      API_STATUS["success"] = initial["success"];
      API_STATUS["isLoading"] = initial["isLoading"];
  }
  return API_STATUS;
};
